import { ListContextProvider, useList } from "ra-core";
import { TasksIterator } from "@/components/atomic-crm/tasks/TasksIterator";
import { useRelatedTasks, type RelatedTasksParams } from "./useRelatedTasks";

/**
 * The related tasks (see useRelatedTasks) through the usual TasksIterator: check, edit, postpone,
 * and done tasks hidden after 5 minutes, with the contact's name.
 */
export const RelatedTasks = ({
  className,
  ...params
}: RelatedTasksParams & { className?: string }) => {
  const { data, isPending, error } = useRelatedTasks(params);
  const listContext = useList({
    data,
    isPending,
    error,
    sort: { field: "due_date", order: "ASC" },
    perPage: 1000,
    resource: "tasks",
  });
  return (
    <ListContextProvider value={listContext}>
      <TasksIterator showContact className={className} />
    </ListContextProvider>
  );
};
